<template>
    <div class="RiskMannFooterEmpresasLista">
        <div v-if="isLoading" class="center-spinner">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <template v-else>
            <header v-if="empresas.length > 0">
                <input type="text" class="form-control rounded mb-3" v-model="buscar" placeholder="Buscar" />
            </header>
            <div :class="{ 'content': !esModal && filtro.length > 0, 'content-modal': esModal && filtro.length > 0 }">
                <div
                    :class="{ 'scroll-body': !esModal && filtro.length > 1, 'scroll-body-modal': esModal && filtro.length > 1 }">
                    <div v-for="(item, index) of filtro" :key="index" class="card cursor-pointer"
                        :class="{ 'selected-item': item.idEmpresa === idEmpresaSeleccionada, 'mt-3': index !== 0, 'mt-2': index === 0 }"
                        @click="seleccionarEmpresa(item.idEmpresa, index)">
                        <div class="card-body d-flex w-100 flex-sm-row flex-column">
                            <div class="me-2">
                                <img class="shadow-sm rounded-pill border border-light"
                                    :src="item.logo ? item.logo : $store.state.imagenes.defecto.foto" alt=""
                                    width="110px" />
                            </div>
                            <p class="card-text">
                                <b>{{ item.razonSocial }}
                                    <i v-if="item.verificada" class="fas fa-check-circle text-primary fs-9 ms-0"></i>
                                </b><br />
                                <b>NIT: </b>{{ item.nit }}<br />
                                <b>Cargo: </b><b class="fw-normal">{{ item.cargo }}</b><br />
                                {{ item.ciudad }},
                                {{ item.departamento === 'Archipiélago de San Andrés, Providencia y Santa Catalina' ?
                                    item.departamento = 'San Andrés y Providencia' : item.departamento
                                }}<br />
                                <b>{{ item.sede }}</b>
                            </p>
                        </div>
                        <span v-if="item.actividades > 0" class="quantity_indicator rounded">
                            {{ item.actividades }}
                        </span>
                    </div>
                </div>
                <div v-if="filtro.length === 0" class="col-md-12 mt-1">
                    <p class="text-center">No se encontraron espacios de trabajo</p>
                    <br>
                    <div class="d-flex justify-content-center">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-outline-primary"
                                @click="cerrar(); $router.push({ name: 'EmpresasMisEmpresasCrearEmpresa' });">
                                Crear un espacio de trabajo
                            </button>
                            <button type="button" class="btn btn-outline-primary"
                                @click="cerrar(); $router.push({ name: 'SolicitudesVinculacion' });">
                                Solicitar vinculación a un espacio de trabajo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <footer class="footer">
                <div v-if="filtro.length > 0 && buscar != ''" class="col-md-12 mt-1">
                    <p class="text-left">Se han encontrado <b>{{ filtro.length }}</b> espacio(s) de trabajo</p>
                </div>
                <div v-if="filtro.length > 0 && !buscar" class="col-md-12 mt-1">
                    <p class="text-left">Tienes <b>{{ filtro.length }}</b> espacio(s) de trabajo</p>
                </div>
            </footer>
        </template>
    </div>
</template>

<script>
import { auth, db } from "@/firebase";
import { collection, query, where, onSnapshot, doc, getDocs, updateDoc } from "firebase/firestore";
import _ from 'lodash';
export default {
    name: "RiskMannFooterEmpresasLista",

    props: {
        esModal: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            idUsuario: "",
            idEmpresaSeleccionada: "",
            buscar: "",
            empresas: [],
            isLoading: false
        }
    },

    computed: {
        filtro() {
            return this.empresas.filter(empresa => {
                return (
                    empresa.nit.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.sede.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.razonSocial.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.ciudad.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.departamento.toLowerCase().includes(this.buscar.toLowerCase()) ||
                    empresa.cargo.toLowerCase().includes(this.buscar.toLowerCase())
                );
            });
        },
    },

    async created() {
        let usuario = auth.currentUser;
        if (usuario) {
            let usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
            if (usuarioDB) {
                this.idUsuario = usuarioDB.id;
                await this.obtenerVinculaciones()
                await this.obtenerEmpresaSeleccionada();
            }
        }
    },

    methods: {
        cerrar() {
            document.getElementById("btnFooterEmpresasCerrar").click();
        },

        async obtenerVinculaciones() {
            /* OBTENER ULTIMAS ACTUALIZACIONES */
            this.isLoading = true;
            this.empresas = [];
            const q = query(
                collection(db, "riskmann_trabajadores"),
                where("idUsuario", "==", this.idUsuario),
                where("estado", "==", "Vinculado"),
                where("registro.estado", "in", ['Creado', 'Editado'])
            );
            const querySnapshot = await getDocs(q);
            const empresas = await Promise.all(
                querySnapshot.docs.map(async (doc) => {
                    return await this.obtenerEmpresa(doc.data());
                })
            );
            this.empresas = empresas.filter((item) => item !== null && item.estado !== 'Eliminado');
            const set = new Set(this.empresas.map(JSON.stringify));
            this.empresas = _.orderBy(Array.from(set).map(JSON.parse), ['consecutivo', 'razonSocial'], ['asc', "asc"]);

            /* COPIAR CONSULTA PARA COMPARAR CAMBIOS */
            const copia = await Promise.all(
                querySnapshot.docs.map((doc) => {
                    return { ...doc.data() }
                })
            );
            this.isLoading = false;

            /* DETECTAR ULTIMOS CAMBIOS */
            let cambios = [];
            onSnapshot(q, (snapshot) => {
                snapshot.docChanges().forEach((change) => {
                    if (change.type === 'added' || change.type === 'modified') {
                        cambios.push(change.doc.data());
                    } else if (change.type === "removed") {
                        for (let index = 0; index < this.empresas.length; index++) {
                            if (change.doc.id == this.empresas[index].id) {
                                this.empresas.splice(index, 1);
                            }
                        }
                    }
                });
                if (!_.isMatch([copia], [cambios]) && _.isMatch([cambios], [copia])) {
                    this.obtenerVinculaciones();
                }
            });
        },

        async obtenerEmpresa(item) {
            const empresa = await this.$store.state.obtenerEmpresa(item.idEmpresa);
            if (empresa) {
                const sede = `${empresa.nit.consecutivo > 0 ? `SUBESPACIO #${empresa.nit.consecutivo}` : "PRINCIPAL"}`
                const obtenerCargo = await this.$store.state.obtenerCargo(item.idCargo);
                const cargo = obtenerCargo ? obtenerCargo.nombre : "SIN CARGO ASIGNADO";
                const actividades = await this.$store.state.planAccion.actividad.funciones.obtenerCantidadResponsable(item.idEmpresa, item.idUsuario);
                return {
                    id: item.id,
                    idEmpresa: item.idEmpresa,
                    cargo: cargo,
                    logo: empresa.logo.url,
                    nit: `${empresa.nit.numero.toString()}-${empresa.nit.digitoVerificacion.toString()}`,
                    sede: sede,
                    razonSocial: empresa.razonSocial,
                    consecutivo: empresa.nit.consecutivo,
                    ciudad: empresa.ubicacion.ciudad,
                    departamento: empresa.ubicacion.departamento,
                    verificada: empresa.verificada,
                    estado: empresa.registro.estado,
                    actividades: actividades
                }
            } else {
                return null;
            }
        },

        async obtenerEmpresaSeleccionada() {
            onSnapshot(doc(db, "riskmann_usuarios", this.idUsuario), async (doc) => {
                if (doc.data().preferencias.idEmpresaSeleccionada) {
                    const obtenerEmpresa = await this.$store.state.obtenerEmpresa(doc.data().preferencias.idEmpresaSeleccionada)
                    if (obtenerEmpresa && obtenerEmpresa.registro.estado !== 'Eliminado') {
                        this.idEmpresaSeleccionada = doc.data().preferencias.idEmpresaSeleccionada;
                        let indice = this.empresas.findIndex((i) => i.idEmpresa === this.idEmpresaSeleccionada);
                        this.cambiarPosicionEmpresa(indice);
                    }
                } else {
                    this.idEmpresaSeleccionada = "";
                }
            });
        },

        async seleccionarEmpresa(id, index) {
            if (id != this.idEmpresaSeleccionada) {
                await updateDoc(doc(db, "riskmann_usuarios", this.idUsuario), {
                    "preferencias.idEmpresaSeleccionada": id,
                });
                this.cambiarPosicionEmpresa(index);
                this.$router.go(0);
            }
        },

        cambiarPosicionEmpresa(index) {
            if (index < 0 || index >= this.empresas.length) {
                console.error('Índice inválido');
            }
            const selectedElement = this.empresas[index];
            this.empresas.splice(index, 1);
            this.empresas.unshift(selectedElement);
        },
    }
}
</script>

<style scoped>
.fs-9 {
    font-size: 9pt
}

.center-spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: hidden;
    left: 50%;
    top: 50%;
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.cursor-pointer {
    cursor: pointer;
}

.scroll-body {
    overflow-y: scroll;
    overflow-x: hidden;
    flex-grow: 1;
    padding-right: 10px;
}

.scroll-body-modal {
    overflow-y: scroll;
    overflow-x: hidden;
    flex-grow: 1;
    padding-right: 10px;
}

.card {
    background-color: #f3f3f3;
}

.selected-item {
    border: 2px solid green;
    background-color: rgba(140, 205, 165, 0.3);
}

.content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 300px;
}

.content-modal {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: calc(64vh - 80px);
}

.fas.fa-check-circle {
    margin-top: 0px;
}

.footer {
    position: sticky;
    bottom: 1;
    z-index: 1;
    margin-top: 10px;
}

.card:hover {
    cursor: pointer;
    transition-duration: 1s;
    box-shadow: none !important;
    border: solid 1px #073d7a !important;
}

.card.selected-item:hover {
    cursor: pointer;
    transition-duration: 1s;
    box-shadow: none !important;
    border: solid 2px green !important;
}

.quantity_indicator {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #E6423C;
    color: white;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
}

@media screen and (max-width: 600px) {
    .content-modal {
        height: calc(55vh - 80px);
    }

    .card img {
        display: grid;
        margin: 0 auto;
        width: 85px;
        margin-bottom: 15px;
    }

    .card-text,
    .card-text b {
        font-size: 10.7pt !important;
    }
}
</style>